/*eslint-disable */
export default {
    'HELLO':                                 'Hallo {name}',
    'SOUND':                                 'Ton',
    'MSG_INCORRECT_PASSWORD':                'Das angegebene Passwort ist nicht korrekt.',
    'MSG_EMAIL_NOT_REGISTERED':              'Diese Email-Adresse ist nicht registriert.',
    'MSG_EMAIL_BLANK':                       'Email darf nicht leer sein.',
    'MSG_EMAIL_IN_USE':                      'Die angegebene Email-Adresse ist bereits in Benutzung.',
    'MSG_PASSWORD_BLANK':                    'Passwort darf nicht leer sein.',
    'MSG_NAME_BLANK':                        'Name darf nicht leer sein.',
    'Path `password` is required.':          'Passwort darf nicht leer sein.',
    'WELCOMEMSG':                            'Willkommen bei MEANager',
    'STATISTICSDESCRIPTION':                 'Ein paar statistische Daten.',
    'SHOPSDESCRIPTION':                      'Sieh dir an, was du geschaffen hast.',
    'ACHIEVEMENTSDESCRIPTION':               'Sieh dir an, was du alles schon erreicht hast.',
    'MANAGERSDESCRIPTION':                   'Diese Leute helfen dir, Waren zu produzieren.',
    'UPGRADESDESCRIPTION':                   'Verbessere deine Läden mit diesen hilfreichen Upgrades.',
    'LOGINDESCRIPTION':                      'Wenn du bereits registriert bist, kannst du dich hier anmelden.',
    'SIGNUPDESCRIPTION':                     'Registriere dich, um deinen Fortschritt auf mehreren Geräten zu nutzen.',
    'SHOPSHEADING':                          'Läden',
    'HIRE_FOR':                              'Einstellen für {costs}',
    'Information':                           'Informationen',
    'BUYX':                                  'x kaufen',
    'BUYFOR':                                'kaufen für {costs}',
    'UPGRADE':                               'Upgrade',
    'UPGRADES':                              'Upgrades',
    'MANAGER':                               'Manager',
    'MANAGERS':                              'Manager',
    'STATISTICS':                            'Statistiken',
    'ACHIEVEMENTS':                          'Auszeichnungen',
    'ACHIEVEMENT':                           'Auszeichnung',
    'NOTACHIEVED':                           'Noch nicht erreicht',
    'ACHIEVEDATE':                           'Erreicht am',
    'LOGIN':                                 'Login',
    'LOGOUT':                                'Logout',
    'RESTART':                               'Neu starten',
    'SIGNUP':                                'Registrieren',
    'CLOSE':                                 'schließen',
    'FOR':                                   'für',
    'APP_HEADLINE':                          'Großartige AngularJS App',
    'NAV_HOME':                              'Zur Startseite',
    'NAV_ABOUT':                             'Über',
    'APP_TEXT':                              'Irgendein Text über eine großartige AngularJS App.',
    'BUTTON_TEXT_EN':                        'EN',
    'BUTTON_TEXT_DE':                        'DE',
    'NUM1E06':                               'Millionen',
    'NUM1E09':                               'Milliarden',
    'NUM1E12':                               'Billionen',
    'NUM1E15':                               'Billiarden',
    'NUM1E18':                               'Trillionen',
    'NUM1E21':                               'Trilliarden',
    'NUM1E24':                               'Quadrillionen',
    'NUM1E27':                               'Quadrilliarden',
    'NUM1E30':                               'Quintillionen',
    'NUM1E33':                               'Quintilliarden',
    'NUM1E36':                               'Sextillionen',
    'NUM1E39':                               'Sextilliarden',
    'NUM1E42':                               'Septillionen',
    'NUM1E45':                               'Septilliarden',
    'NUM1E48':                               'Oktillionen',
    'NUM1E51':                               'Oktilliarden',
    'NUM1E54':                               'Nonillionen',
    'NUM1E57':                               'Nonilliarden',
    'NUM1E60':                               'Dezillionen',
    'NUM1E63':                               'Dezilliarden',
    'NUM1E66':                               'Undezillionen',
    'NUM1E69':                               'Undezilliarden',
    'NUM1E72':                               'Dodezillionen',
    'NUM1E75':                               'Dodezilliarden',
    'NUM1E78':                               'Tredezillionen',
    'NUM1E81':                               'Tredezilliarden',
    'NUM1E84':                               'Quattuordezillionen',
    'NUM1E87':                               'Quattuordezilliarden',
    'NUM1E90':                               'Quindezillionen',
    'NUM1E93':                               'Quindezilliarden',
    'NUM1E96':                               'Sedezillionen',
    'NUM1E99':                               'Sedezilliarden',
    'NUM1E100':                              'Googol',
    'CURRENCY':                              'EUR',
    'EDIT':                                  'bearbeiten',
    'LemonadeStand':                         'Limonadenstand',
    'Lemonade stand':                        'Limonadenstand',
    'Paper delivery':                        'Zeitungsausträger',
    'PaperDelivery':                         'Zeitungsausträger',
    'MANAGER_00_DESC':                       'Der Schnibbel-König. Ist gerne bereit, dir für ein geringes Entgelt unter die Arme zu greifen.',
    'MANAGER_01_DESC':                       'Hat sich bei ihrem früheren Job mal blamiert, kann aber weit werfen.',
    'MANAGER_02_DESC':                       'Trägt auch selber Schuhe.',
    'MANAGER_03_DESC':                       'Hat in den 90ern Pizza Connection gespielt.',
    'MANAGER_04_DESC':                       'Manche halten ihn für einen Clown, dabei ist er eigentlich überhaupt nicht lustig.',
    'MANAGER_05_DESC':                       'Nur die Heinzelmännchen backen schneller.',
    'MANAGER_06_DESC':                       'Fährt einen dicken BMW, raucht wie ein Schlot aber bestellt und telefoniert wie kein zweiter.',
    'MANAGER_07_DESC':                       'Jahrelange Vereinsmitgliedschaft machen ihn selbst zum treuesten Fan.',
    'MANAGER_08_DESC':                       'Der Action-Spezialist direkt aus Hollywood.',
    'MANAGER_09_DESC':                       'Flugpionier, Kampffliegerausbildung, Abschluss in Flugwissenschaften.',
    'MANAGER_10_DESC':                       'Kaum Vorstrafen, Ex-Broker und per Du mit der Kanzlerin.',
    'MANAGER_11_DESC':                       'Folgt einer langen Familientradition im Autobau.',
    'MANAGER_12_DESC':                       'Seine Feinde nennen ihn nur \'Die Keule\'. Seine Freunde auch.',
    'SHOP_AUTOUPGRADE_COOLDOWN_MSG':         'Produktionszeit für {shopName} um den Faktor {factor} verkürzt!',
    'SHOP_AUTOUPGRADE_EARNINGS_MSG':         'Verdienst für {shopName} x {factor}!',
    'MANAGEDBY':                             'Wird von {manager} gemanaget',
    'Balance':                               'Kontostand',
    'Lifetime earnings':                     'Gesamteinnahmen',
    'LIFETIME_EARNINGS':                     'Gesamteinnahmen',
    'No data available':                     'Keine Daten vorhanden',
    'Session earnings':                      'Einnahmen während aktueller Sitzung',
    'SESSION_EARNINGS':                      'Einnahmen während aktueller Sitzung',
    'Bank':                                  'Bank',
    'Soccer team':                           'Fußballmannschaft',
    'SoccerTeam':                            'Fußballmannschaft',
    'Movie studio':                          'Filmstudio',
    'MovieStudio':                           'Filmstudio',
    'Social network':                        'Soziales Netzwerk',
    'SocialNetwork':                         'Soziales Netzwerk',
    'Lamp store':                            'Lampenladen',
    'LampStore':                             'Lampenladen',
    'Bakery':                                'Bäckerei',
    'Shoe shop':                             'Schuhladen',
    'ShoeShop':                              'Schuhladen',
    'Pizza delivery':                        'Pizza-Dienst',
    'PizzaDelivery':                         'Pizza-Dienst',
    'Drug ring':                             'Drogenring',
    'DrugRing':                              'Drogenring',
    'Help from the neighbour\'s kids':       'Hilfe von den Nachbarskindern',
    'Billboard advertising':                 'Werbetafel',
    'Lemon squeezer 5000':                   'Zitronenpresse 5000',
    'Straws':                                'Strohhalme',
    'Fancy umbrellas':                       'Kleine Schirmchen',
    'Additional brochures':                  'Zusätzliche Werbeprospekte',
    'Baking mixture':                        'Backmischungen',
    'Flavor enhancers':                      'Geschmacksverstärker',
    'Lunch specials':                        'Mittagstisch',
    'Crash-proof planes':                    'Absturzsichere Fluzeuge',
    'Air marshals':                          'Air marshals',
    'Colorful flags':                        'Bunte Fähnchen',
    'Ice cubes':                             'Eiswürfel',
    'Credit cards':                          'Kreditkarten',
    'Tax saving program':                    'Neues Steuersparmodell',
    'Bitcoin trading':                       'Bitcoin-Handel',
    'Giant novelty cheques':                 'Riesige Papp-Schecks',
    'Newspaper cannons':                     'Zeitungskanonen',
    'Low orbit newspaper delivery':          'Weltall-Lieferung',
    'Party service':                         'Partyservice',
    'Self-cutting lemons':                   'Selbstschneidende Zitronen',
    'Free refills':                          'Kostenloses Nachfüllen',
    'Insider trading':                       'Insider-Handel',
    'Hostile takeover':                      'Feindliche Übernahme',
    'Lobbyist':                              'Lobbyist',
    'Add tequila':                           '...mit Schuss',
    'Restructuring':                         'Umstrukturierungsmaßnahmen',
    'Downsizing of human resources':         'Abbau von Humankapital',
    'Brain trust':                           'Brain Trust',
    'Vending machines':                      'Getränkeautomaten',
    'Consulting firm':                       'Unternehmensberater',
    'Tax accountant':                        'Steuerberater',
    'Investment strategy':                   'Investitionsstrategie',
    'Electric bulbs':                        'Glühlampen',
    'Warehouse':                             'Eigenes Lager',
    'Bigger assortment':                     'Größeres Sortiment',
    'Own brand':                             'Eigenmarke',
    'Lamp exhibition':                       'Lampenausstellung',
    'Foot X-Ray':                            'Fuß-Röntgengerät',
    'Sell single shoes':                     'Schuh-Einzelverkauf',
    'Colorful shoe laces':                   'Bunte Schnürbänder',
    'Self-produced leather':                 'Selbst hergestelltes Leder',
    'Third world production country':        'Produktion in Dritte-Welt-Land',
    'Child labor':                           'Kinderarbeit',
    'Blinking shoes':                        'Blinkende Schuhe',
    'Platforms':                             'Plateauschuhe',
    'UKK boots':                             'UKK boots',
    'Store cards':                           'Kundenkarten',
    'Shoe flat-rate':                        'Schuh-Flatrate',
    'Inlays':                                'Einlagen',
    'Famous designer product line':          'Designer-Schuhe',
    '3D projector':                          '3D-Projektor',
    'Electronic ticketing':                  'Elektronisches Ticketsystem',
    'Popcorn':                               'Popcorn',
    'Ice cups':                              'Eiskonfekt',
    'Smelly-Vision':                         'Geruchsfilme',
    'Surround sound':                        'Surround-Sound',
    'Smoking theatre':                       'Raucher-Säle',
    'Own productions':                       'Eigenproduktionen',
    'Film festival':                         'Filmfestival',
    'Double features':                       'Double Features',
    'Additional length surcharges':          'Überlängenzuschläge',
    'Soft drinks':                           'Softdrinks',
    'Short films':                           'Kurzfilme',
    'Triple features':                       'Tripple features',
    'Sneak previews':                        'Sneak previews',
    'Adult movies':                          'Erwachsenenfilme',
    'Silent movies':                         'Stummfilme',
    'Cuddle seats':                          'Kuschelsitze',
    'Laser shows':                           'Lasershows',
    'Working DRM':                           'Funktionierendes DRM',
    'Anti-privacy campaign':                 'Anti-Piraterie-Kampagne',
    'Divine proportion':                     'Goldener Schnitt',
    'Root of all evil':                      'Wurzel allen Unheils',
    '\'e\'-commerce':                        '\'E\'-Commerce',
    'Tasty pies':                            'Pi-ttoreske Geschäfte',
    'Acceleration!':                         'Beschleunigung!',
    'Sports live streaming':                 'Sport-Liveübertragungen',
    'Concerts live streaming':               'Konzert-Liveübertragungen',
    'Designer lamps':                        'Designerlampen',
    'Office equipment':                      'Büroausstattung',
    'Smart home':                            'Smart home',
    'Own app':                               'Eigene App',
    'Sell accessories':                      'Zubehörverkauf',
    'Merchant shop':                         'Händler-Shop',
    'Sales representative':                  'Verkaufsvertreter',
    'Solar panels':                          'Solarzellen',
    'Smear campaign':                        'Schmierkampagne',
    'Concrete shoes':                        'Betonschuhe',
    'Shoe shine':                            'Schuhputzer',
    'Shoe care product line':                'Schuhpflege-Produktlinie',
    'Self-running shoes':                    'Selbstlaufende Schuhe',
    'Certified vocational training company': 'Anerkannter Ausbildungsbetrieb',
    'Sharper knives':                        'Schärfere Messer',
    'Juicier lemons':                        'Saftigere Zitronen',
    'Bike':                                  'Fahrrad',
    'Bike trailer':                          'Fahrradanhänger',
    'Shoulder bag':                          'Umhängetasche',
    'Raincoat':                              'Regenjacke',
    'Spring collection':                     'Frühjahrskollektion',
    'Winter collection':                     'Winterkollektion',
    'Summer collection':                     'Sommerkollektion',
    'Shoehorn':                              'Schuhlöffel',
    'Stone oven':                            'Steinofen',
    'Luigi\'s secret sauce recipe':          'Luigis geheimes Soßenrezept',
    'Dishwasher':                            'Geschirrspülmaschine',
    'Kneading machine':                      'Knetmaschine',
    'Pre-cut bread':                         'Geschnitten Brot',
    'Move up the league':                    'Aufstieg',
    'Star trainer':                          'Startrainer',
    'Advertising boards':                    'Werbebanden',
    'Main sponsor':                          'Hauptsponsor',
    'Champions League':                      'Champions League',
    'Women\'s team':                         'Frauenmannschaft',
    'Robots team':                           'Roboter-Mannschaft',
    'First class':                           'Erste Klasse',
    'New routes':                            'Neue Flugrouten',
    'Supersonic planes':                     'Überschallflugzeuge',
    'Bigger fleet':                          'Größere Flotte',
    'Giant vault':                           'Riesiger Tresor',
    'Higher interest':                       'Höhere Zinsen',
    'Money press':                           'Gelddruckmaschine',
    'Bank stability program':                'Europäischer Stabilitätsmechanismus',
    'New dealers':                           'Neue Dealer',
    'Homegrown weed':                        'Selbstanbau',
    'Automatic weapons':                     'Automatische Waffen',
    'New trending drug':                     'Neue Szenedroge',
    'Smuggle planes':                        'Schmuggelflugzeug',
    'Stadium':                               'Stadion',
    'Football ground':                       'Bolzplatz',
    'Millionaire':                           'Millionär',
    'Billionaire':                           'Millardär',
    'Sextillionaire':                        'Trilliardär',
    'Sexdecillionaire':                      'Oktilliardär',
    'Googolnaire':                           'Googolnär',
    'INTERPOLATETEST':                       'interpolate {test}%',
    'UpgradeShowIncomePerSecond':            'Einnahmen/s',
    'Shows earnings per second':             'Zeigt Verdienst pro Sekunde an',
    'Shows total earnings per second':       'Zeigt Gesamtverdienst pro Sekunde an',
    'EARNINGSFOR':                           'Einnahmen für',
    'UPGRADE_DECREASE_PRODUCTION_TIME':      'Verkürzt die Produktionszeit für {shop} um das {factor}fache',
    'UPGRADE_INCREASE_EARNINGS':             'Erhöht den Verdienst für {shop} um das {factor}fache',
    'all shops':                             'alle Läden',
    'allShops':                              'alle Läden',
    'SHOPS':                                 'Läden',
    'all':                                   'alle Läden',
    'MANAGE_TEXT':                           'Betreut {shopType}.',
    'TOGGLENAV':                             'Navigation anzeigen/ausblenden',
    'Credit screening':                      'Bonitätsprüfung',
    'Spam campaign':                         'Spam-Kampagne',
    'Newsletter campaign':                   'Newsletter-Kampagne',
    'AdWords campaign':                      'AdWords-Kampagne',
    'Drone shipping':                        'Drohnenversand',
    'Content agency':                        'Content-Agentur',
    'SEO agency':                            'SEO-Agentur',
    'Service partner':                       'Servicepartner',
    'Premium service partner':               'Premium-Servicepartner',
    'SEO optimizations':                     'SEO-Optimierung',
    'StoreWare online shop':                 'StoreWare Onlineshop',
    'tx;commerce online shop':               'tx;commerce Onlineshop',
    'Magenta online shop':                   'Magenta Onlineshop',
    'Trainee':                               'Praktikant',
    'Express delivery':                      'Expresslieferung',
    'Local newspaper ads':                   'Werbung in der Lokalzeitung',
    'TV ads':                                'TV-Werbung',
    'Radio ads':                             'Radio-Werbung',
    'Trusted Shops certification':           'Trusted Shops-Zertifizierung',
    'TÜV certification':                     'TÜV-Zertifizierung',
    'Price comparison portal':               'Anmeldung bei Preisvergleichsportalen',
    'Phone book entry':                      'Telefonbucheintrag',
    'Youth department':                      'Jugendabteilung',
    'ACHIEVEMENT_BALANCE':                   'Hab mehr als {balance} auf deinem Konto.',
    'ACHIEVEMENT_BRANCHES':                  'Baue {branches} Filialen von jedem Laden.',
    '1 of everything':                       'Eine Filiale von allen Läden',
    '100 of everything':                     '100 Filialen von allen Läden',
    '500 of everything':                     '500 Filialen von allen Läden',
    '1000 of everything':                    '1000 Filialen von allen Läden',
    '2222 of everything':                    '2222 Filialen von allen Läden',
    '10000 of everything':                   '10000 Filialen von allen Läden',
    '100000 of everything':                  '100000 Filialen von allen Läden',
    '1000000 of everything':                 '1000000 Filialen von allen Läden',
    'BUYXFOR':                               '{amount} x kaufen für {price}',
    'UPGRADE_POSITIVE':                      'Juhu!',
    'UPGRADE_NEGATIVE':                      'Oh nein!',
    'earnings':                              'Einnahmen',
    'for':                                   'für',
    'productionTime':                        'Produktionszeit',
    'New competitor!':                       'Neue Konkurrenz!',
    'EVT_FIRE':                              'Feuer bei {shop}!',
    'EVT_BOOST':                             'Turboboost!',
    'EVT_ROBBERY':                           'Überfall!',
    'EVT_JACKPOT':                           'Lotto-Jackpot!',
    'EVT_BANK_ERROR_FAVOR':                  'Bankirrtum zu deinen Gunsten',
    'EVT_BANK_ERROR_NOT_FAVOR':              'Bankirrtum zu deinen Ungunsten',
    'EVT_BEAUTY_CONTEST':                    'Du hast den 3. Preis in einer Schönheitskonkurrenz gewonnen.',
    'EVT_GENERAL_REPAIRS':                   'Lasse alle deine Shops renovieren. Für jeden Shop zahle {singleCost}.',
    'EVT_CROSSWORD':                         'Du hast einen Kreuzworträtselwettbewerb gewonnen.',
    'GONEFOR':                               'Du warst {time} weg.',
    'INCOMEGENERATEDWHILEGONE':              'In dieser Zeit hast du {income} verdient.',
    'EMAIL':                                 'Email',
    'PASSWORD':                              'Passwort',
    'NAME':                                  'Name',
    'INVALIDMAIL':                           'Das sieht nicht nach einer korrekten Email-Adresse aus.',
    'GIVEMEYOURMAIL':                        'Wie lautet deine Email-Adresse?',
    'PASSWORDMINTEXT':                       'Passwort muss mindestens 3 Zeichen haben.',
    'NAMEREQUIRED':                          'Du hast deinen Namen vergessen.',
    'CURRENTPASSWORD':                       'Aktuelles Passwort',
    'NEWPASSWORD':                           'Neues Passwort',
    'SAVECHANGES':                           'Änderungen speichern',
    'CHANGEPASSWORD':                        'Passwort ändern',
    'PASSWORDCHANGEOK':                      'Passwort erfolgreich geändert.',
    'PASSWORDINCORRECT':                     'Falsches Passwort',
    'HOWTOPLAY':                             'Wie spielt man?',
    'HOWTOPLAY_STEP1':                       'Baue neue Läden im Tab \'Läden\'.',
    'HOWTOPLAY_STEP2':                       'Produziere Waren und verdiene Geld.',
    'HOWTOPLAY_STEP3':                       'Stelle Manager ein, die die Produktion für dich übernehmen,',
    'HOWTOPLAY_STEP4':                       'Verbesser deine Läden im Tab \'Upgrades\'.',
    'HOWTOPLAY_STEP5':                       'Baue mehr Filialen.',
    'HOWTOPLAY_STEP6':                       'Hoffe, dass dir keine schlimmen Dinge passieren.',
    'HOWTOPLAY_STEP7':                       'Verdiene so viel Geld wie möglich.',
    'CONNECTION_LOST':                       'Das Spiel kann so leider nicht weitergehen... Warte ein bisschen.',
    'CONNECTION_LOST_HEADLINE':              'Verbindung zum Server verloren!',
    'CONNECTION_FOUND':                      'Es kann jetzt weitergehen.',
    'CONNECTION_FOUND_HEADLINE':             'Verbindung wiederhergestellt!',
    'RESET_GAME':                            'Spiel zurücksetzen',
    'EVT_FLOOD':                             'Flutschaden',
    'EVT_CEASE_DESIST':                      'Abmahnung',
    'EVT_SHOP_USEBILITY':                    'Du hast einen Shop-Usability-Contest gewonnen.',
    'AMOUNTTOBUILD':                         'Baue',
    'UPGRADE_ALREADY_APPLIED':               'bereits gekauft',
    'MANAGER_ALREADY_HIRED':                 'bereits eingestellt',
    'DELETE_CONFIRM':                        'Ganz sicher? Alle Spieldaten werden gelöscht.',
    'NO':                                    'Nein',
    'YES':                                   'Ja',
    'TUTORIAL_STEP1_TITLE':                  'Laden kaufen',
    'TUTORIAL_STEP1_TEXT':                   'Klicke den \'Läden\'-Tab.',
    'TUTORIAL_STEP2_TITLE':                  'Limonadenstand',
    'TUTORIAL_STEP2_TEXT':                   'Klicke auf den Kaufen-Button, um einen Limonadenstand zu kaufen.',
    'TUTORIAL_STEP3_TITLE':                  'Produzieren',
    'TUTORIAL_STEP3_TEXT':                   'Klicke auf das Icon, um Limonade zu produzieren und Geld zu verdienen.',
    'TUTORIAL_STEP4_TITLE':                  'Mehr Filialen!',
    'TUTORIAL_STEP4_TEXT':                   'Baue eine weitere Filiale, um deinen Verdienst zu erhöhen.',
    'TUTORIAL_STEP5_TITLE':                  'Reibach',
    'TUTORIAL_STEP5_TEXT':                   'Produziere weiter, bis du 60€ verdient hast.',
    'TUTORIAL_STEP6_TITLE':                  'Zeitungsausträger',
    'TUTORIAL_STEP6_TEXT':                   'Klicke auf den Kaufen-Button, um einen Zeitungsausträger zu kaufen.',
    'TUTORIAL_STEP7_TITLE':                  'Reibach',
    'TUTORIAL_STEP7_TEXT':                   'Produziere mit allen Shops weiter, bis du 1000€ verdient hast.',
    'TUTORIAL_STEP8_TITLE':                  'Manager einstellen',
    'TUTORIAL_STEP8_TEXT':                   'Klicke den \'Manager\'-Tab',
    'TUTORIAL_STEP9_TITLE':                  'Limonadenstand-Manager',
    'TUTORIAL_STEP9_TEXT':                   'Klicke den Einstellen-Button, um einen Manager für den Limonadestand einzustellen.',
    'TUTORIAL_STEP10_TITLE':                 'Produzieren lassen',
    'TUTORIAL_STEP10_TEXT':                  'Gehe zurück zum \'Läden\'-Tab.',
    'TUTORIAL_STEP11_TITLE':                 'Automatisch produzieren',
    'TUTORIAL_STEP11_TEXT':                  'Produziere nochmals Limonade. Anschließend übernimmt der Manager.',
    'TUTORIAL_FINISHED_HEADLINE':            'Tutorial abgeschlossen',
    'TUTORIAL_FINISHED_TEXT':                'Glückwunsch, du weisst jetzt wie man spielt. Kaufe jetzt mehr Läden und baue mehr Filialen, um weiter Geld zu verdienen. Schau dich außerdem mal bei den Upgrades um. Viel Erfolg!',
    'CONNECT_FACEBOOK':                      'Mit Facebook anmelden',
    'CONNECT_GPLUS':                         'Mit Google+ anmelden',
    'CONNECT_TWITTER':                       'Mit Twitter anmelden',
    'RANKING':                               'Bestenliste',
    'Car manufacturer':                      'Autohersteller',
    'CarManufacturer':                       'Autohersteller',
    'Light lemonade':                        'Light-Limonade',
    'Crystal lemonade':                      'Kristall-Limonade',
    'BOGOF':                                 'Zwei zum Preis von einer',
    'Forged health study':                   'Gefälschte Gesundheitsstudie',
    'Addition of caffeine':                  'Zusatz von Koffein',
    'More flavors':                          'Mehr Geschmacksrichtungen',
    'Bottling plant':                        'Abfüllanlage',
    'Digital issue':                         'Digitalausgabe',
    'Self publishing':                       'Selbstverlag',
    'Printing press':                        'Druckpresse',
    'Nationwide delivery':                   'Überreginale Auslieferung',
    'Feuilleton':                            'Feuilleton',
    'Sports section':                        'Sportteil',
    'Obituaries':                            'Todesanzeigen',
    'Economy section':                       'Wirtschaftsteil',
    'Foreign correspondent':                 'Auslandskorrespondent',
    'Editorial department':                  'Redaktion',
    'TV programme':                          'TV-Programm',
    'Horoscope':                             'Horoskop',
    'Pulitzer Prize':                        'Pulitzer-Preis',
    'Crossword puzzle':                      'Kreuzworträtsel',
    'Native olive oil':                      'Natives Olivenöl Extra',
    'Cheap paper pizza boxes':               'Billige Papier-Pizzakartons',
    'Real italian cook':                     'Echter italienischer Pizzabäcker',
    'Printed menus':                         'Gedruckte Speisekarten',
    'Scooter':                               'Roller',
    'Car':                                   'Auto',
    'Helicopter':                            'Helikopter',
    'Instant pizza':                         'Instant-Pizza',
    'Frozen pizza':                          'Tiefkühlpizza',
    'Verace Pizza Napoletana':               'Verace Pizza Napoletana',
    'Pizza cutter':                          'Pizzaschneider',
    'Peel':                                  'Pizzaschieber',
    'Low-carb':                              'Low-Carb',
    'Cheese crust':                          'Käsekruste',
    'Pizza world champion':                  'Pizzabäcker-Weltmeister',
    'Wedding cakes':                         'Hochzeitstorten',
    'Cheese analogue':                       'Analogkäse',
    'Gluten-free goods':                     'Glutenfreie Backwaren',
    'Sandwiches':                            'Belegte Brötchen',
    'Bockwurst with bread':                  'Bockwurst mit Brötchen',
    'Coffee shop':                           'Cafe',
    'Bakerman is baking bread':              'Bakerman is baking bread',
    'Locally milled flour':                  'Lokal gemahlenes Mehl',
    'Bio grade bread':                       'Bio-Qualität',
    'Wholesale bakery':                      'Großbäckerei',
    'Franchise bakery':                      'Franchise-Bäckerei',
    'Investment banking':                    'Investmentbank',
    'Big bank':                              'Großbank',
    'Fettes Brot':                           'Fettes Brot',
    'Pastry chef':                           'Konditor',
    'Bigger oven':                           'Größerer Ofen',
    'Baking courses':                        'Backkurse',
    'Self-service':                          'Selbstbedienung',
    'Bulk order':                            'Großauftrag',
    'Antique oil lamps':                     'Antike Öllampen',
    'Grow lamps':                            'Grow-Lampen',
    'Industrial lighting':                   'Industriebeleuchtung',
    'Darklights':                            'Dunkelleuchten',
    'Power generating lights':               'Stromerzeugende Leuchten',
    'Gas lights':                            'Gaslicht',
    'Superluminal velocity lights':          'Überlichtgeschwindigkeitslampen',
    'Fitness coach':                         'Fitness-Trainer',
    'Medical team':                          'Mannschaftsarzt',
    'Press department':                      'Presseabteilung',
    'PR tour through Asia':                  'PR-Tour durch Asien',
    'Sporting director':                     'Sportdirektor',
    'Doping':                                'Doping',
    'Intercontinental Cup winner':           'Weltpokalsieger',
    'International merchandise':             'Internationaler Merchandise',
    'Become FIFA president':                 'Wahl zum FIFA-Präsidenten',
    'League winner':                         'Deutscher Meister',
    'Talent scouts':                         'Talentscouts',
    'Initial public offering':               'Börsengang',
    'Sexy stewardesses':                     'Sexy Stewardessen',
    'Sexy stewards':                         'Sexy Stewards',
    'Charter flights':                       'Charterflüge',
    'Own airport':                           'Eigener Flughafen',
    'Package holidays':                      'Pauschalreisen',
    'More legroom':                          'Mehr Beinfreiheit',
    'Autopilot':                             'Autopilot',
    'Tomato juice':                          'Tomatensaft',
    'Tax free shopping':                     'Zollfrei einkaufen',
    'Miles bonus program':                   'Meilen-Bonusprogramm',
    'Solar planes':                          'Solarflugzeuge',
    'In-flight entertainment':               'In-flight Entertainment',
    'Internet access':                       'Internetzugang',
    'Business class':                        'Business-Klasse',
    'Flight to the moon':                    'Flug zum Mond',
    'ATMs':                                  'EC-Automaten',
    'Stock trading':                         'Wertpapierhandel',
    'Safe deposit boxes':                    'Schließfächer',
    'Insurances':                            'Versicherungen',
    'Call center':                           'Call-Center',
    'Online banking':                        'Online-Banking',
    'Phone banking':                         'Telefon-Banking',
    'Transaction fees':                      'Transaktionsgebühren',
    'Assembly lines':                        'Fließbänder',
    'Welding robots':                        'Schweißroboter',
    'Self-driving cars':                     'Selbstfahrende Autos',
    'Airbags':                               'Airbags',
    'ESP':                                   'ESP',
    'ABS':                                   'ABS',
    'Bio fuel powered cars':                 'Biosprit-Motoren',
    'Electric cars':                         'Elektro-Autos',
    'Luxury brand':                          'Luxus-Marke',
    'Supersonic car':                        'Überschall-Auto',
    'Flying car':                            'Fliegendes Auto',
    'Limousine':                             'Limousine',
    'Family van':                            'Familien-Van',
    'SUV':                                   'SUV',
    'Plane':                                 'Flugzeug',
    'Netflix series':                        'Eigene Netflix-Serie',
    'Amphibious vehicles':                   'Amphibienfahrzeuge',
    'Convertible':                           'Cabrio',
    'Car rental':                            'Autovermietung',
    'Leasing':                               'Leasing',
    'Unflattable tires':                     'Unplattbare Reifen',
    'Car museum':                            'Automobil-Museum',
    'Racing team':                           'Rennstall',
    'Drug lab':                              'Drogenküche',
    'Own country':                           'Eigenes Land',
    'Bulk pack smuggle condoms':             'Großpackung Schmuggel-Kondome',
    'Marihuana legalization':                'Marihuana-Legalisierung',
    'Speedboat':                             'Schnellboot',
    'Opium poppy fields':                    'Schlafmohnfelder',
    'Greenhouse':                            'Gewächshaus',
    'Counterfeited drugs':                   'Gefälschte Drogen',
    'Smuggle tunnel':                        'Schmuggel-Tunnel',
    'Invisibility cloak':                    'Tarnkappe',
    'Get rid of competitor':                 'Konkurrent loswerden',
    'Bribes':                                'Bestechungen',
    'Goon squad':                            'Schlägertrupp',
    'Killer commando':                       'Killer-Kommando',
    'CHEATER_MSG_BODY':                      'Dein Spielstand wurde modifiziert... Du musst neu starten.',
    'CHEATER_MSG_HEADING':                   'Cheat-Versuch erkannt!',
    'EVT_STRIKE':                            'Streik!',
    'Strike':                                'Streik',
    'ON_STRIKE_FOR':                         'Keine Produktion für {duration} Sekunden.',
    'FOR_SHOP':                              'Für {shop}',
    'Social media expert':                   'Social-Media-Experte',
    'YOUR_STATS':                            'Deine Punkte: {points}',
    'PLAYER_COUNT':                          'Spieler online: {count}',
    'PLAYER':                                'Spieler',
    'POINTS':                                'Punkte',
    'DATE':                                  'Datum',
    'HIDE_APPLIED':                          'Gekaufte ausblenden',
    'ACHIEVEMENT_TITLE':                     '{amount} x {shop}',
    'HIDE_ACHIEVED':                         'Erreichte ausblenden',
    'GENERAL':                               'allgemein',
    'WAITING_FOR_SERVER':                    'Warte auf Serververbindung...',
    'Missing credentials':                   'Fehlende Zugangsdaten',
    'Path `email` is required.':             'Email fehlt'
}
